export const SHOPIFY_APP_STORE_URL = 'https://apps.shopify.com/chargemont';
